<template>
  <v-container class="mt-0 pt-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined class="mx-auto" elevation="2">
          <div class="d-flex justify-end pr-4 pt-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                  color="primary"
                  style="cursor: pointer;"
                >
                  mdi-information
                </v-icon>
              </template>

              <span>
                Esta consulta recupera o número de solicitações abertas e fechadas por tipo. A consulta:
                <ul>
                  <li>Aberto: Número de solicitações abertas cuja data de criação está entre ({{day}}).</li>
                  <li>Fechado: Número de solicitações que tiveram alguma das interações "Finalizado, Cancelada ou Finalizado Erro", entre ({{day}}).</li>
                </ul>
              </span>
            </v-tooltip>
            <v-icon @click="downloadPNG" class="ml-2" style="color: #4d638c;">mdi-file-png-box</v-icon>
            <v-icon v-if="showMdiWindowMax" @click="changeCols('12'); showMdiWindowMax = !showMdiWindowMax" class="ml-2">mdi-window-maximize</v-icon>
            <v-icon v-else @click="changeCols('6'); showMdiWindowMax = !showMdiWindowMax" class="ml-2">mdi-window-restore</v-icon>
          </div>
          <v-col v-if="loading" class="col-md-12 d-flex justify-center align-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
          <v-col v-if="showErrorMessage" class="col-md-12 d-flex justify-center align-center">
            {{messageError}}
          </v-col>
          <div v-show="!loading" style="position: relative; height: 100%; width: 100%">
            <canvas ref="solicitationType"></canvas>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { mapActions, mapState } from "vuex";

export default {
  props: {
    selectedDate: {
      type: Object,
    },
    day: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      loading: true,
      messageError: '',
      chartInstance: null,
      showErrorMessage: false,
      showMdiWindowMax: true,
    };
  },
  async mounted() {},
  computed: {
    ...mapState("dashboard", ["solicitaionTypeOpenClosed"])
  },
  methods: {
    ...mapActions("dashboard", ['loadSolicitaionTypeOpenClosed']),
    changeCols(val) {
      this.$emit('changeCols', val);
    },
    downloadPNG() {
      const link = document.createElement("a");
      link.href = this.chartInstance.toBase64Image();
      link.download = "SolicitationTypeOpenClosed.png";
      link.click();
    },
    async loadDataComponent() {
      try {
        this.loading = true;
        if (this.chartInstance) {
          this.chartInstance.destroy();
        }
        await this.loadSolicitaionTypeOpenClosed(this.selectedDate);
        this.day = this.solicitaionTypeOpenClosed.interval;
        this.graph(this.solicitaionTypeOpenClosed.data);
      } catch (error) {
        this.loading = false;
        this.showErrorMessage = true;
        this.messageError = error.message;
        this.$swal("Oops...", error.message, "error");
      }
    },

    graph(data) {
      const labels = Object.keys(data);
      const createdData = labels.map(label => data[label].open);
      const closedData = labels.map(label => data[label].closed);
      const maxValue = Math.max(...createdData, ...closedData);
      const maxScale = Math.ceil(maxValue / 5) * 6;

      const ctx = this.$refs.solicitationType;

      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Aberto',
              data: createdData,
              backgroundColor: 'rgb(46, 58, 89)',
              borderColor: 'rgb(46, 58, 89)',
              borderWidth: 1,
            },
            {
              label: 'Fechado',
              data: closedData,
              backgroundColor: 'rgb(231,80,90)',
              borderColor: 'rgb(231,80,90)',
              borderWidth: 1
            }
          ]
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: [
                'Tipos de Solicitações - ( ' + this.day + ')',
              ],
              color: 'black',
              font: {
                size: 20,
                weight: 'bold',
              },
              align: 'center',
            },
            datalabels: {
              anchor: 'end',
              align: 'end',
              formatter: (value, context) => {
                return value;
              },
              font: {
                weight: 'bold'
              },
            },
          },
          indexAxis: 'y',
          scales: {
            x: {
              max: maxScale,
              beginAtZero: true,
              title: {
                display: true,
                text: 'Número de solicitações'
              },
              ticks: {
                callback: function(value) {
                  return Number.isInteger(value) ? value : null;
                }
              }
            },
            y: {
              ticks: {
                align: 'start'
              },
              title: {
                display: true,
                text: 'Tipos de Solicitações'
              }
            }
          }
        },
        plugins: [ChartDataLabels]
      });
      this.loading = false;
    }
  },
  watch: {
    async selectedDate(newDate) {
      await this.loadDataComponent(newDate);
    }
  },
};
</script>
<style scoped></style>
